
        <div fNodeInput *ngFor="let input of node.inputs" [fInputId]="input" class="left" fOutputConnectableSide="left"
            [fInputMultiple]="node.multiple"></div>
        <div fNodeOutput *ngFor="let output of trueOutput" [fOutputId]="output" fOutputConnectableSide="right" class="right-top"
            [fOutputMultiple]="false" ></div>
        <div fNodeOutput *ngFor="let output of falseOutput" [fOutputId]="output"   fOutputConnectableSide="right" class="right-bottom"
            [fOutputMultiple]="false"></div>

      
        <mat-icon fDragHandle class="wh-node-toggle-icon-drag" *ngIf="selectedVersion?.status=='DRAFT'">drag_indicator</mat-icon>
        
        <nz-switch [(ngModel)]="node.active" [nzSize]="'small'" class="wh-node-activation"></nz-switch>


        <label nz-checkbox class="debug" *ngIf="debug" [(ngModel)]="node.debug">{{'debug'|translateTA}}</label>    
        
        <div class="node-content">
            <div class="wh-node-title">
               {{node.componentName|translateTA}}
            </div>
        </div>
        <div class="wh-node-name" *ngIf="node.name!=null && node.name!=''">
            <span class="wh-node-name-text">{{node.name}}</span>
        </div>   

        @let log = getDebuggingLog();
        <div class="wh-node-log" *ngIf="debug && log!=null">
            <nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" *ngIf="log?.error==false && log?.resultList.length>0" (click)="openResult(log)" />
            <nz-icon nzType="warning" nzTheme="twotone" nzTwotoneColor="#eb4034" *ngIf="log?.error==true"  (click)="openResult(log)"/>
        </div>
        
        
        <div class="wh-node-status" [style.backgroundColor]="color"></div>
    
        <!--div class="wh-node-status-left" style.backgroundColor="red"></div>
        <div class="wh-node-status-right" style.backgroundColor="green"></div-->